export default {
      id: "chevronDown-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#chevronDown-usage",
      toString: function () {
        return this.url;
      }
    }